import { render, staticRenderFns } from "./TextFilter.vue?vue&type=template&id=bf6ef8a4&scoped=true&class=text-filter&"
import script from "./TextFilter.vue?vue&type=script&lang=js&"
export * from "./TextFilter.vue?vue&type=script&lang=js&"
import style0 from "./TextFilter.vue?vue&type=style&index=0&id=bf6ef8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6ef8a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VDialog,VListItem,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
